import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="10 0 44 64" {...props}>
    <path d="M43.5 0L53 9.5L30.5 32L53 54.5L43.5 64L11.5 32L43.5 0Z" />
  </IconBox>
);
